import {
  Component,
  ElementRef,
  inject,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { BlockableUI } from '@openng/optimus-ui/api';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'blockable-div',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './blockable-div.component.html',
})
export class BlockableDiv implements BlockableUI {
  @Input() style: any;
  @Input() class: any;
  el = inject(ElementRef);

  getBlockableElement(): HTMLElement {
    return this.el.nativeElement.children[0];
  }
}
